import { Dialog, CircularProgress, Button } from '@material-ui/core';
import enUs from '../../../../lang/en-us';
import * as React from 'react';
import { getOtmData } from '../../../../redux-store/actions/newPurchase';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import { OTMVerifyStatus, PaymentTypes } from './types';

const { dbCommercial } = enUs;

type OTMCheckPropsType = {
    amc: string;
    getOtmData: any;
    setPurchaseType: React.Dispatch<any>;
    otmVerifyStatus: OTMVerifyStatus;
    setOtmVerifyStatus: React.Dispatch<React.SetStateAction<OTMVerifyStatus>>;
    purchaseType: PaymentTypes;
};

function OTMCheck({
    amc,
    getOtmData,
    setPurchaseType,
    purchaseType,
    otmVerifyStatus,
    setOtmVerifyStatus,
}: OTMCheckPropsType) {
    const history = useHistory();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);

    React.useEffect(() => {
        async function callApi() {
            try {
                setLoading(true);
                const {
                    body: { data },
                } = await getOtmData({ amc });
                if (!data || data?.length === 0) {
                    setOtmVerifyStatus(OTMVerifyStatus.NOT_VALID);
                    setError(true);
                } else {
                    setOtmVerifyStatus(OTMVerifyStatus.VALID);
                }
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        if (purchaseType === PaymentTypes.SIP) {
            if (otmVerifyStatus === OTMVerifyStatus.NOT_SET) {
                callApi();
            }
        }
    }, [purchaseType]);
    return (
        <>
            <Dialog maxWidth={'sm'} open={loading} aria-labelledby="enable-fingerprint-modal">
                <div className="enable-fingerprint-modal">
                    <CircularProgress />
                    <p>{dbCommercial.otmStatus.checking}</p>
                </div>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                open={
                    (error || otmVerifyStatus === OTMVerifyStatus.NOT_VALID) &&
                    purchaseType === PaymentTypes.SIP
                }
                aria-labelledby="note-modals"
            >
                <div className="note-modals">
                    <h3>{dbCommercial.otmStatus.heading}</h3>
                    <p style={{ marginBottom: 15 }}>{dbCommercial.otmStatus.info1}</p>
                    <div className="note-modals-btns">
                        <Button
                            className="customBtn cancelBtn"
                            onClick={() => {
                                setPurchaseType(PaymentTypes.Lumpsum);
                                setError(false);
                            }}
                        >
                            {dbCommercial.otmStatus.lumpsum}
                        </Button>
                        <Button
                            className="customBtn"
                            onClick={() => {
                                history.replace('/portal/commercial/emandate');
                            }}
                            style={{
                              width: "60%"
                            }}
                        >
                            {dbCommercial.otmStatus.eMandate}
                        </Button>
                    </div>
                </div>
            </Dialog>
        </>
    );
}

export default connect(null, { getOtmData })(OTMCheck);
